import { DollarSignIcon, HandCoinsIcon, ListX, SpellCheck, Undo2 } from "lucide-react";
import { match } from "ts-pattern";

import { ForgeHistoryLog } from "@coinbot/forge-api/trpc";

import { RunePriceBadge, ThornameBadge } from "~/components/inline";
import { useSwapKit } from "~/context/swapkit";

export const useTxHistoryDetailsByHistoryLog = (historyLog: ForgeHistoryLog) => {
  const swapkit = useSwapKit();
  const { name, price, chain, txHash } = historyLog;

  const explorerUrl = swapkit?.client?.getExplorerTxUrl({ chain, txHash });

  const thorname = <ThornameBadge name={name} />;
  const runePrice = <RunePriceBadge price={price} />;

  const details = match(historyLog)
    .with({ type: "buy" }, () => ({
      icon: <DollarSignIcon className="w-4 text-[#25D285]" />,
      title: (
        <>
          Bought {thorname} for {runePrice}.
        </>
      ),
      explorerUrl,
    }))
    .with({ type: "listing_fee" }, () => ({
      icon: <HandCoinsIcon className="w-4 text-[#25D285]" />,
      title: <>Transferred listing fee for {thorname}.</>,
      explorerUrl,
    }))
    .with({ type: "ownership_transfer" }, () => ({
      icon: <SpellCheck className="w-4 text-[#25D285]" />,
      title: <>Transferred ownership of {thorname}.</>,
      explorerUrl,
    }))
    .with({ type: "sell" }, () => ({
      icon: <DollarSignIcon className="w-4 text-yellow-400" />,
      title: (
        <>
          Sold {thorname} for {runePrice}.
        </>
      ),
      explorerUrl,
    }))
    .with({ type: "listing_removed_auto_tns_close_to_expiry" }, () => ({
      icon: <Undo2 className="w-4 text-red-400" />,
      title: (
        <>
          Auto-returned {thorname} THORName to your wallet - it was approaching its{" "}
          <b className="text-red-300">expiry date</b>.
        </>
      ),
      explorerUrl,
    }))
    .with({ type: "listing_removed_manually" }, () => ({
      icon: <ListX className="w-4 text-red-400" />,
      title: <>Removed {thorname} market listing. THORName was returned to your wallet.</>,
      explorerUrl,
    }))
    .otherwise(() => ({
      title: undefined,
      icon: undefined,
      explorerUrl: undefined,
    }));

  return details;
};
